// GA4 analytics — loads ONLY on production, never on the preview or localhost.
const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

const isProd = () => {
  if (!GA_ID || typeof window === "undefined") return false;
  const h = window.location.hostname;
  return (
    !h.includes("preview.emergentagent.com") &&
    h !== "localhost" &&
    h !== "127.0.0.1"
  );
};

let initialized = false;

export const hasConsent = () =>
  typeof window !== "undefined" && localStorage.getItem("wmdw_consent") === "granted";

export const initGA = () => {
  if (initialized || !isProd() || !hasConsent()) return;
  initialized = true;

  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", GA_ID);
};

export const trackEvent = (name, params = {}) => {
  if (!isProd() || typeof window.gtag !== "function") return;
  window.gtag("event", name, params);
};
